import { Ramp } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';

export const NewsLetterBoxTitle = (props: {
  type?: 'title' | 'subTitle',
}) => {
  const {
    type,
  } = props;
  const containerRampName = type === 'title' ? 'titleContainer' : 'subTitleContainer';
  const contentRampName = type === 'title' ? 'titleContent' : 'subTitleContent';
  return (
    <Ramp
      rampName={containerRampName}
    >
      <Ramp
        rampName={contentRampName}
      />
    </Ramp>
  );
};
